import { z } from 'zod'
import { IsoDateString } from '../../common'
import { Guid } from '../common-schemas'
import { EmailAddressValue, emailAddressValueSchema } from '../Email/EmailTypes'

export const csvExportEntitySchema = z.enum(['ACCOUNTS', 'ESTIMATES', 'MAINTENANCE_PLANS', 'PAYMENTS'])
export type CsvExportEntity = z.infer<typeof csvExportEntitySchema>

export type CsvExportRequestedEventData<TPayload = unknown> = {
  entity: CsvExportEntity
  emailTo: EmailAddressValue
  requestedByUserGuid: Guid
  requestedAt: IsoDateString
  payload: TPayload
}

export const baseCsvExportRequestSchema = z.object({
  emailTo: emailAddressValueSchema,
  fieldIds: z.array(z.string()).min(1, 'At least one field must be selected'),
})

export type BaseCsvExportRequest = z.infer<typeof baseCsvExportRequestSchema>
